module.exports = __webpack_public_path__ + "image/v_bg2.png";